<template>
  <div>
    <b-row>
      <b-col>
        <h4>Seleção de vínculos ao certificado</h4>
        <fieldset class="font-weight-bold text-muted small">
          Selecione as empresas (e-CNPJ) ou sócios (e-CPF) que deseja vincular neste certificado
        </fieldset>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-row>
          <b-col>
            <fieldset
              class="font-weight-bold pt-2 mb-1"
              style="font-size: medium;"
            >
              Vinculadas
            </fieldset>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="temFiltroRapido"
            cols="3"
          >
            <filtro-rapido
              :disabled="disabled"
              :filtros="filtrosRapidosVinculados"
              :filtro-atual="filtroAtualVinculada"
              @selecionado="aplicarFiltroRapidoVinculadas($event)"
            />
          </b-col>
          <b-col cols="9">
            <busca-input
              v-model="buscaDigitadaVinculada"
              :disabled="disabled"
              class="mb-1"
              :placeholder="'Buscar por palavra chave'"
              @input="buscar(true)"
              @clean="cleanInputVinculada"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
              ref="tabelaVinculadas"
              class="vinculo-grid"
              max-height="375px"
              :columns="colunas"
              :rows="vinculadasSelecionadas"
              :fixed-header="false"
              :is-loading.sync="isCarregandoVinculada"
              @on-row-click="addDesvinculadas"
              @on-sort-change="onOrdenacaoAlteradaVinculadas"
            >
              <div slot="emptystate">
                <p style="text-align:center; margin:0">
                  Nenhum dado vinculado.
                </p>
              </div>

              <template
                slot="table-row"
                slot-scope="props"
              >
                <span
                  :class="[{ 'text-danger': !props.row.ativa}]"
                >
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col style="padding-right: unset;">
            <fieldset
              class="font-weight-bold pt-2 mb-1"
              style="font-size: medium;"
            >
              Desvinculadas
            </fieldset>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="temFiltroRapido"
            cols="3"
          >
            <filtro-rapido
              :disabled="disabled"
              :filtros="filtrosRapidos"
              :filtro-atual="filtroAtual"
              @selecionado="aplicarFiltroRapido($event)"
            />
          </b-col>
          <b-col
            cols="9"
          >
            <busca-input
              v-model="buscaDigitadaNaoVinculada"
              :disabled="disabled"
              class="mb-1"
              :placeholder="visualizacaoOpcoes.placeholderBusca ? visualizacaoOpcoes.placeholderBusca : 'Buscar por palavra chave'"
              @input="buscar(false)"
              @clean="cleanInputNaoVinculada"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
              ref="tabelaNaoVinculadas"
              class="vinculo-grid"
              max-height="375px"
              :columns="colunas"
              :rows="valueInner.naoVinculadas"
              :fixed-header="false"
              :is-loading.sync="isCarregandoDesvinculadas"
              @on-row-click="addVinculadas"
              @on-sort-change="onOrdenacaoAlteradaNaoVinculadas"
            >
              <div slot="emptystate">
                <p style="text-align:center; margin:0">
                  Nenhum dado desvinculado.
                </p>
              </div>

              <template
                slot="table-row"
                slot-scope="props"
              >
                <span
                  :class="[{ 'text-danger': !props.row.ativa}]"
                >
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2" />
    <b-row>
      <b-col>
        <span class="m-50">
          Total de {{ valueInner.totalVinculadas }} itens
        </span>
      </b-col>
      <b-col>
        <span class="m-50">
          Total de {{ valueInner.totalNaoVinculadas }} itens
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn
          :disabled="disabled"
          variant="none"
          class="btn-outline-danger mt-1 mr-50 btn-sm"
          @click="clearVinculadas"
        >Desvincular Todas</b-btn>
      </b-col>
      <b-col class="text-left">
        <b-btn
          :disabled="disabled"
          variant="none"
          class="btn-outline-success mt-1 btn-sm"
          @click="clearDesvinculadas"
        >Vincular Todas</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

table.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0;
  border-top: 0 !important;
}

table.vgt-table thead {
  position: sticky;
  top: 0;
  background-color: white;
}

table.vgt-table thead tr:first-child th {
  border-top: 1px solid #dcdfe6 !important
}

table.vgt-table th, .vgt-table td {
  border-width: .5px !important
}

.vinculo-grid {
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(122, 122, 122, 0.4);
      border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      // background-color: $primary;
      -webkit-box-shadow: inset 0 0 15px $primary;
  }

  .nowrap {
    white-space: nowrap !important;
  }

}

.servico-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.disable-table {
  pointer-events: none;
}
</style>
<script>
import {
  required,
} from '@validations'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'UsuarioInterno',
  components: {
    VueGoodTable,
    FiltroRapido: () => import('@/app-modulo/comuns/certificado/shared/components/filtro-rapido/FiltroRapido.vue'),
    BuscaInput: () => import('@/app-modulo/comuns/certificado/shared/components/busca-input/BuscaInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    vinculadas: {
      type: Array,
      default: () => [],
    },
    cadastroUsuario: {
      type: Boolean,
      default: true,
    },
    visualizacaoOpcoes: {
      type: Object,
      required: true,
    },
    filtrosVinculadas: {
      type: Array,
      default: () => [],
    },
    filtrosNaoVinculadas: {
      type: Array,
      default: () => [],
    },
    filtrosRapidos: {
      type: Array,
      default: () => [],
    },
    filtrosRapidosVinculados: {
      type: Array,
      default: () => [],
    },
    temFiltroRapido: {
      type: Boolean,
      default: false,
    },
    temBusca: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCarregandoVinculada: false,
      isCarregandoDesvinculadas: false,
      required,
      valueInner: {
        id: 0,
        vinculadas: [],
        naoVinculadas: [],
        totalVinculadas: 0,
        totalNaoVinculadas: 0,
      },
      colunas: [
        {
          label: 'Inscrição',
          field: 'cadastroFederal',
          tdClass: 'nowrap',
          sortable: false,
        },
        { label: 'Nome', field: 'razaoSocial', sortable: false }],
      buscaDigitadaVinculada: '',
      buscaDigitadaNaoVinculada: '',
      filtroAtivoVinculadas: {
        filtroBy: [],
        ordemBy: [],
      },
      filtroAtivoNaoVinculadas: {
        filtroBy: [],
        ordemBy: [],
      },
      filtroImutavel: [],
      filtroAtual: null,
      filtroAtualVinculada: null,
      idsVinculadas: [],
      filtros: [
        {
          colunas: ['nome', 'registrofederal', 'integracao'],
          valor: null,
        },
      ],
      vinculadasSelecionadas: [],
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.idsVinculadas = this.valueInner.vinculadas.map(empresa => empresa.id)
        this.atualizarContadores()
      }
    },
    vinculadas(value, oldValue) {
      if (value !== oldValue) {
        this.vinculadasSelecionadas = value
        this.idsVinculadas = value.map(empresa => empresa.id)
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.vinculadasSelecionadas = this.vinculadas
    this.filtroImutavel = [...this.filtrosNaoVinculadas]
    this.filtroAtivoVinculadas.filtroBy = this.filtrosVinculadas
    this.filtroAtivoNaoVinculadas.filtroBy = this.filtrosNaoVinculadas
    this.atualizarContadores()
  },
  methods: {
    buscar(vinculadas) {
      if (!this.isCarregandoVinculada || !this.isCarregandoDesvinculadas) {
        if (vinculadas) {
          this.montarGrid(this.filtroAtivoVinculadas, vinculadas)
        } else {
          this.montarGrid(this.filtroAtivoNaoVinculadas, vinculadas)
        }
      }
    },
    cleanInputVinculada() {
      this.buscaDigitadaVinculada = ''
      this.buscar(true)
    },
    cleanInputNaoVinculada() {
      this.buscaDigitadaNaoVinculada = ''
      this.buscar(false)
    },
    addVinculadas(params) {
      if (!this.disabled) {
        this.idsVinculadas.push(params.row.id)
        this.valueInner.vinculadas.push(params.row)
        this.valueInner.naoVinculadas.splice(params.pageIndex, 1)
        this.vinculadasSelecionadas = this.valueInner.vinculadas
        this.atualizarContadores()
      }
    },

    addDesvinculadas(params) {
      if (!this.disabled) {
        const index = this.idsVinculadas.indexOf(params.row.id)
        this.idsVinculadas.splice(index, 1)
        this.valueInner.naoVinculadas.push(params.row)
        this.valueInner.vinculadas.splice(params.pageIndex, 1)
        this.vinculadasSelecionadas = this.valueInner.vinculadas
        this.atualizarContadores()
      }
    },

    clearDesvinculadas() {
      while (this.valueInner.naoVinculadas.length > 0) {
        const vinculada = this.valueInner.naoVinculadas.pop()
        this.valueInner.vinculadas.push(vinculada)
        this.idsVinculadas.push(vinculada.id)
      }
      this.atualizarContadores()
    },

    clearVinculadas() {
      while (this.valueInner.vinculadas.length > 0) {
        const desvinculada = this.valueInner.vinculadas.pop()
        this.valueInner.naoVinculadas.push(desvinculada)
        const index = this.idsVinculadas.indexOf(desvinculada.id)
        this.idsVinculadas.splice(index, 1)
      }
      this.vinculadasSelecionadas = this.valueInner.vinculadas
      this.atualizarContadores()
    },
    atualizarContadores() {
      if (this.valueInner.naoVinculadas.length > 0) {
        this.valueInner.totalNaoVinculadas = this.valueInner.naoVinculadas.length
      }
      if (this.valueInner.naoVinculadas && this.valueInner.naoVinculadas.length === 0) {
        this.$set(this.valueInner, 'totalNaoVinculadas', 0)
      }
      if (this.valueInner.vinculadas.length > 0) {
        this.valueInner.totalVinculadas = this.valueInner.vinculadas.length
      }
      if (this.valueInner.vinculadas && this.valueInner.vinculadas.length === 0) {
        this.$set(this.valueInner, 'totalVinculadas', 0)
      }
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    aplicarFiltroRapido(filtro, filtroInterno = true) {
      this.filtroAtivoNaoVinculadas.filtroBy = filtro !== null ? this.filtroAtivoNaoVinculadas.filtroBy : [...this.filtroImutavel]
      const index = filtroInterno ? this.filtroAtivoNaoVinculadas.filtroBy.findIndex(where => where.filtroInterno)
        : this.filtroAtivoNaoVinculadas.filtroBy.findIndex(where => where.colunas.length === 1 && where.colunas.some(any => filtro === null || any === (filtro.colunas[0])))
      if (index >= 0) {
        this.filtroAtivoNaoVinculadas.filtroBy.splice(index, 1)
      }
      if (filtro && filtro !== null) {
        // eslint-disable-next-line no-param-reassign
        filtro.filtroInterno = filtroInterno
        this.filtroAtivoNaoVinculadas.filtroBy.push(filtro)
        this.alterarRota(filtro)
      }
      this.montarGrid(this.filtroAtivoNaoVinculadas, false)
    },
    aplicarFiltroRapidoVinculadas(filtro, filtroInterno = true) {
      this.filtroAtivoVinculadas.filtroBy = filtro !== null ? this.filtroAtivoVinculadas.filtroBy : [...this.filtroImutavel]
      const index = filtroInterno ? this.filtroAtivoVinculadas.filtroBy.findIndex(where => where.filtroInterno)
        : this.filtroAtivoVinculadas.filtroBy.findIndex(where => where.colunas.length === 1 && where.colunas.some(any => filtro === null || any === (filtro.colunas[0])))
      if (index >= 0) {
        this.filtroAtivoVinculadas.filtroBy.splice(index, 1)
      }
      if (filtro && filtro !== null) {
        // eslint-disable-next-line no-param-reassign
        filtro.filtroInterno = filtroInterno
        this.filtroAtivoVinculadas.filtroBy.push(filtro)
        this.alterarRota(filtro)
      }
      this.montarGrid(this.filtroAtivoVinculadas, true)
    },
    filtroRapidoViaQuery() {
      const query = this.$route.query.filtroRapido
      if (query && this.filtrosRapidos) {
        const item = this.filtrosRapidos.find(find => find.id === query)
        if (item) {
          this.aplicarFiltroRapido(item)
          return true
        }
      }
      return false
    },
    alterarRota(filtro) {
      let alterar = false
      const queries = JSON.parse(JSON.stringify(this.$route.query || {}))
      if (queries.buscaNaoVinculada !== this.buscaDigitadaNaoVinculada) {
        queries.buscaNaoVinculada = this.buscaDigitadaNaoVinculada
        alterar = true
      }
      if (queries.buscaVinculada !== this.buscaDigitadaVinculada) {
        queries.buscaVinculada = this.buscaDigitadaVinculada
        alterar = true
      }
      if (filtro && queries.filtroRapido !== filtro.id) {
        // eslint-disable-next-line prefer-destructuring
        queries.filtroRapido = filtro.id
        alterar = true
      }
      if (alterar) {
        this.$router.replace({ query: queries })
      }
    },
    montarGrid(enviarServidor, vinculadas) {
      if (vinculadas) {
        this.isCarregandoVinculada = true
      } else {
        this.isCarregandoDesvinculadas = true
      }
      this.setValorFiltro()
      this.visualizacaoOpcoes.evento(this.valueInner.id,
        {
          filtro: enviarServidor,
          idsVinculadas: this.idsVinculadas,
          isVinculada: vinculadas,
          modeloCertificado: this.valueInner.modelo,
        })
        .then(payload => {
          if (vinculadas) {
            this.vinculadasSelecionadas = payload.data
          } else {
            this.valueInner.naoVinculadas = payload.data
          }
          this.atualizarContadores()
          this.isCarregandoVinculada = false
          this.isCarregandoDesvinculadas = false
        })
        .catch(err => {
          this.isCarregandoVinculada = false
          this.isCarregandoDesvinculadas = false
          throw err
        })
    },
    setValorFiltro() {
      if (this.filtroAtivoVinculadas.filtroBy && this.filtroAtivoVinculadas.filtroBy.length > 0) {
        this.filtroAtivoVinculadas.filtroBy[0].valor = this.buscaDigitadaVinculada
      }
      if (this.filtroAtivoNaoVinculadas.filtroBy && this.filtroAtivoNaoVinculadas.filtroBy.length > 0) {
        this.filtroAtivoNaoVinculadas.filtroBy[0].valor = this.buscaDigitadaNaoVinculada
      }
    },
    onOrdenacaoAlteradaVinculadas(param) {
      const colOrdenada = param[0]
      this.filtroAtivoVinculadas.ordemBy = [{
        tipo: colOrdenada.type,
        coluna: colOrdenada.field,
      }]
      this.montarGrid(this.filtroAtivoVinculadas, true)
    },
    onOrdenacaoAlteradaNaoVinculadas(param) {
      const colOrdenada = param[0]
      this.filtroAtivoNaoVinculadas.ordemBy = [{
        tipo: colOrdenada.type,
        coluna: colOrdenada.field,
      }]
      this.montarGrid(this.filtroAtivoNaoVinculadas, false)
    },
  },
}
</script>
